import React from 'react';
import { Accordion, Stack, Title, Text, Box, ScrollArea, Button, Image, Group } from '@mantine/core';
import { NavLink } from 'react-router-dom';
import { hasDescription } from '../Features/Technology';
import { createTechnologyTableData, getLogoUrl } from '../Features/Technology/shared';
import { Blip } from '../Features/Radar';
import DataTable from './DataTable';
import useRingColors from '../Hooks/use-ring-colors';
import { Ring } from '../../backend/models/ring';
import { Person } from '../../backend/models/person';

type PropType = {
  groupedResult: { [key: string]: Blip[] };
  onMouseOver?: (blip: Blip) => void;
  onMouseLeave?: () => void;
  rings: Ring[];
  persons: Person[];
};

const SectionTechnologyList = (props: PropType) => {
  const { groupedResult, onMouseOver, onMouseLeave, rings, persons } = props;
  const { ringColors } = useRingColors();
  return (
    <>
      {Object.keys(groupedResult)
        .sort((a: string, b: string) => rings.findIndex((r) => r.id === a) - rings.findIndex((r) => r.id === b))
        .map((key) => {
          const ringName = rings.find((r) => r.id === key)?.name;
          const list = groupedResult[key];
          const ringIndex = rings.findIndex((r) => r.id === key);

          return (
            <div key={key}>
              <Group align={'center'} mb={'xs'}>
                <div style={{ width: 40, height: 25, backgroundColor: ringColors[ringIndex], borderRadius: 4 }} />
                <Title order={3}>{ringName}</Title>
              </Group>
              <Accordion radius="md" mb={'lg'} defaultValue={null}>
                {list.map((blip) => (
                  <Accordion.Item
                    value={blip.name}
                    key={blip.name}
                    onMouseOver={() => onMouseOver && onMouseOver(blip)}
                    onMouseLeave={onMouseLeave}
                  >
                    <Accordion.Control p={'xs'}>
                      <Text fw={500} fz={'sm'}>{`${blip.number ? `${blip.number}. ` : ''}${blip.name}`}</Text>
                    </Accordion.Control>
                    <Accordion.Panel>
                      <ScrollArea.Autosize maxHeight={500} type={'always'} offsetScrollbars scrollbarSize={6}>
                        <Stack fz={'sm'} spacing={'xs'} pt={'sm'} pb={'sm'}>
                          {blip.logoUrl && (
                            <Image width={'auto'} height={50} fit="contain" src={getLogoUrl(blip.logoUrl)} />
                          )}
                          <DataTable data={createTechnologyTableData(blip, persons)} />
                          {hasDescription(blip.description) && (
                            <Box dangerouslySetInnerHTML={{ __html: blip.description as string }} />
                          )}
                          <Button component={NavLink} to={`/technology/${encodeURIComponent(blip.name)}`} fullWidth>
                            {'To technology page'}
                          </Button>
                        </Stack>
                      </ScrollArea.Autosize>
                    </Accordion.Panel>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          );
        })}
    </>
  );
};

export default SectionTechnologyList;
